// @flow

export const FETCHING_RECORDINGS = 'FETCHING_RECORDINGS';
export const FETCHING_HEATMAPS = 'FETCHING_HEATMAPS';
export const FETCHING_HEATMAP_SOURCE_URL = 'FETCHING_HEATMAP_SOURCE_URL';
export const FETCHING_QUERY_DATA = 'FETCHING_QUERY_DATA';
export const FETCHING_REPORTS = 'FETCHING_REPORTS';
export const FETCHING_CAMPAIGNS = 'FETCHING_CAMPAIGNS';
export const FETCHING_LOCATIONS = 'FETCHING_LOCATIONS';
